// Helpers: resuelve label/category de un módulo o sidebar-item según
// el archetype actual de la org. Permite que la misma ModuleDefinition
// se presente con distinto nombre y categoría según tipo de empresa.
//
// Patrón:
//   const { name, category } = resolveModule(mod, archetype);
//   const itemLabel = resolveItemLabel(mod, 'agenda', archetype);

import type { ModuleCategory, ModuleDefinition, SidebarItem } from './types';

export function resolveModule(
  m: ModuleDefinition,
  archetype: string | null,
): { name: string; category: ModuleCategory } {
  if (!archetype || !m.byArchetype) {
    return { name: m.name, category: m.category };
  }
  const override = m.byArchetype[archetype];
  if (!override) return { name: m.name, category: m.category };
  return {
    name: override.name ?? m.name,
    category: override.category ?? m.category,
  };
}

export function resolveItemLabel(
  m: ModuleDefinition,
  item: SidebarItem,
  archetype: string | null,
): string {
  if (!archetype || !m.byArchetype) return item.label;
  const override = m.byArchetype[archetype];
  if (!override?.sidebarItems) return item.label;
  return override.sidebarItems[item.tab]?.label ?? item.label;
}
